import { useEffect } from 'react';
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';
import usePageMeta from '../../../hooks/usePageMeta';

export default function HistoryPage() {
  usePageMeta({
    title: '미래인재학원 연혁 - 민락·옥정·지행',
    description: '2019년 설립 후 9개 캠퍼스 확장! 지행 3관, 옥정 3관, 민락 3관 운영 중. 학생 우선 교육 철학으로 지역 최대 규모 입시학원으로 성장.',
    path: '/about/history',
    schemaType: 'WebPage',
    keywords: '미래인재학원 연혁, 학원 역사, 지행캠퍼스, 옥정캠퍼스, 민락캠퍼스, 개원',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const milestones = [
    {
      year: '2019년 7월',
      title: '미래인재학원',
      subtitle: '지행캠퍼스 1관 개관',
      description: '동두천시 지행지구에서 미래인재학원의 첫 발걸음 시작',
      icon: 'ri-seedling-line',
      facilityLink: 'https://blog.naver.com/eliteoffuture/222517259403'
    },
    {
      year: '2020년 2월',
      title: '미래인재학원',
      subtitle: '지행캠퍼스 2관 개관',
      description: '지행지구에 고등관을 추가 오픈하며 중·고등 통합 교육 시스템 완성',
      icon: 'ri-building-line',
      facilityLink: 'https://blog.naver.com/eliteoffuture/222516459185'
    },
    {
      year: '2021년 1월',
      title: '미래인재학원',
      subtitle: '옥정캠퍼스 1관 개관',
      description: '양주시 옥정지구에 새로운 캠퍼스를 오픈하며 교육 영역 확장',
      icon: 'ri-map-pin-add-line',
      facilityLink: 'https://blog.naver.com/eliteoffuture/222517264922'
    },
    {
      year: '2021년 11월',
      title: '미래인재학원',
      subtitle: '지행캠퍼스 3관 개관',
      description: '지행지구에 초등 프리미엄관을 오픈하며 체계적인 교육 시스템 구축',
      icon: 'ri-star-line',
      facilityLink: 'https://blog.naver.com/eliteoffuture/222573861369'
    },
    {
      year: '2022년 3월',
      title: '미래인재학원',
      subtitle: '옥정캠퍼스 2관 개관',
      description: '옥정지구에 두 번째 캠퍼스 오픈으로 더 많은 학생들에게 양질의 교육 제공',
      icon: 'ri-building-line',
      facilityLink: 'https://blog.naver.com/eliteoffuture/222676797209'
    },
    {
      year: '2022년 11월',
      title: '미래인재학원',
      subtitle: '옥정캠퍼스 3관 개관',
      description: '옥정지구에 세 번째 캠퍼스를 추가하며 프리미엄 교육 환경 완성',
      icon: 'ri-star-line',
      facilityLink: 'https://blog.naver.com/eliteoffuture/222941604568'
    },
    {
      year: '2023년 11월',
      title: '미래인재학원',
      subtitle: '민락캠퍼스 1관 개관',
      description: '의정부 민락지구에 새로운 캠퍼스를 오픈하며 교육 영역 확대',
      icon: 'ri-map-pin-add-line',
      facilityLink: 'https://blog.naver.com/eliteoffuture/223265944409'
    },
    {
      year: '2024년 3월',
      title: '미래인재학원',
      subtitle: '민락캠퍼스 2관 개관',
      description: '민락지구에 두 번째 캠퍼스 오픈으로 교육 인프라 강화',
      icon: 'ri-building-line',
      facilityLink: 'https://blog.naver.com/eliteoffuture/223467018704'
    },
    {
      year: '2025년 5월',
      title: '미래인재학원',
      subtitle: '민락캠퍼스 3관 개관',
      description: '민락지구에 세 번째 캠퍼스를 오픈하며 더욱 확장된 교육 서비스 제공',
      icon: 'ri-building-2-line',
      facilityLink: 'https://blog.naver.com/eliteoffuture/223969385464'
    }
  ];

  return (
    <div className="min-h-screen bg-neutral-950">
      <Navigation />

      {/* Vision Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-20 left-10 w-72 h-72 bg-yellow-400/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-yellow-400/5 rounded-full blur-3xl"></div>
        </div>

        <div className="max-w-6xl mx-auto px-6 relative z-10">
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-2 bg-yellow-400/10 text-yellow-400 text-sm font-medium rounded-full mb-6">
              Our Vision
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              앞으로의 <span className="text-yellow-400">다짐</span>
            </h2>
            <p className="text-lg text-neutral-400 max-w-2xl mx-auto">
              미래인재학원의 모든 결정의 순간에는&nbsp;<br />
              언제나 '학생'이 우선이었습니다.<br />
              그간 보내주신 깊은 관심과 성원을<br className="md:hidden" /> 가슴 깊이 새기며,<br />
              앞으로도 항상 학생을 먼저 생각하는<br className="md:hidden" /> 미래인재학원이 되도록 노력하겠습니다.<br /><br />
              미래인재학원 대표 및 전 직원 올림
            </p>
          </div>
        </div>
      </section>

      {/* Hero Section */}
      <section className="py-20 bg-neutral-900/50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-1 gap-12 items-center">
            <div className="text-center">
              <span className="inline-block px-4 py-2 bg-yellow-400/10 text-yellow-400 text-base font-medium rounded-full mb-6">
                Our History
              </span>
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                미래인재학원의<br className="md:hidden" /> <span className="text-yellow-400">연혁</span>
              </h1>
              <p className="text-neutral-400 text-base md:text-lg leading-relaxed">
                2019년 설립 이후, 학생들의 성장과 함께<br className="md:hidden" />
                발전해온 미래인재학원의 여정을 소개합니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="py-20 relative">
        <div className="max-w-4xl mx-auto px-6">
          <div className="relative">
            {/* Timeline Line */}
            <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-yellow-400 via-yellow-400/50 to-transparent transform md:-translate-x-1/2"></div>

            {/* Timeline Items */}
            <div className="space-y-12">
              {milestones.map((milestone, index) => (
                <div
                  key={milestone.year}
                  className={`relative flex items-center ${
                    index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                  }`}
                >
                  {/* Year Badge */}
                  <div className="absolute left-8 md:left-1/2 transform -translate-x-1/2 z-10">
                    <div className="w-16 h-16 bg-neutral-900 border-2 border-yellow-400 rounded-full flex items-center justify-center">
                      <i className={`${milestone.icon} text-yellow-400 text-xl`}></i>
                    </div>
                  </div>

                  {/* Content Card */}
                  <div className={`ml-24 md:ml-0 md:w-5/12 ${index % 2 === 0 ? 'md:pr-16' : 'md:pl-16'}`}>
                    <div className="bg-neutral-900/80 backdrop-blur-sm border border-neutral-800 rounded-2xl p-6 hover:border-yellow-400/30 transition-all duration-300 group">
                      <div className="flex items-center gap-3 mb-4 flex-wrap">
                        <span className="inline-block px-3 py-1 bg-yellow-400 text-black text-sm font-bold rounded-full">
                          {milestone.year}
                        </span>
                        {milestone.facilityLink && (
                          <a
                            href={milestone.facilityLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 px-3 py-1 bg-neutral-800 text-yellow-400 text-sm font-semibold rounded-full hover:bg-neutral-700 transition-colors cursor-pointer whitespace-nowrap border border-yellow-400/30"
                          >
                            <i className="ri-building-4-line"></i>
                            시설보기
                          </a>
                        )}
                      </div>
                      <h3 className="text-xl font-bold text-white mb-1 group-hover:text-yellow-400 transition-colors">
                        {milestone.title}
                      </h3>
                      <p className="text-lg font-semibold text-yellow-400/90 mb-3">
                        {milestone.subtitle}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
}
